import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import MainContentWrapper from '../components/layout/MainContentWrapper';
import ErrorMessage from '../components/ui/ErrorMessage';
import Spinner from '../components/ui/Spinner';

const READY_DELAY_MS = 300;
const TRANSITION_DURATION_MS = 600;

export const createFetchingView = (Component) => {
  class FetchingView extends React.PureComponent {
    state = {
      isReady: false,
      isFadedOut: false,
    };

    componentDidMount() {
      this.hasMounted = true;

      if (!this.props.isFetching) {
        setTimeout(this.setReady, READY_DELAY_MS);
      }
    }

    componentWillReceiveProps(nextProps) {
      const {
        isFetching,
      } = this.props;

      if (!this.state.ready) {
        if (isFetching && isFetching !== nextProps.isFetching) {
          setTimeout(this.setReady, READY_DELAY_MS);
        }
      }
    }

    componentWillUnmount() {
      this.hasMounted = false;
    }

    setReady = () => {
      if (this.hasMounted) {
        this.setState({ isReady: true });
        setTimeout(this.setFadedOut, TRANSITION_DURATION_MS);
      }
    };

    setFadedOut = () => {
      if (this.hasMounted) {
        this.setState({ isFadedOut: true });
      }
    };

    setFetching = (isFetching) => {
      if (this.hasMounted) {
        const isReady = !isFetching;

        if (isReady) {
          this.setState({
            isReady: true
          });

          setTimeout(this.setFadedOut, TRANSITION_DURATION_MS);
        } else {
          this.setState({
            isFadedOut: false,
            isReady: false,
          });
        }
      }
    };

    renderSpinner() {
      const {
        isReady,
      } = this.state;

      return (
        <Spinner
          isReady={isReady}
          transitionDuration={TRANSITION_DURATION_MS}
        />
      );
    }

    renderFailure() {
      const {
        isReady,
      } = this.state;

      return (
        <ErrorMessage
          isReady={isReady}
          transitionDuration={TRANSITION_DURATION_MS}
        />
      );
    }

    renderComponent() {
      return (
        <Component
          {...this.props}
          isReady={this.state.isReady}
          setFetching={this.setFetching}
        />
      );
    }

    render() {
      const {
        isReady,
        isFadedOut,
      } = this.state;

      const {
        status
      } = this.props;

      return (
        <MainContentWrapper
          isReady={isReady}
          id="MainContentWrapper"
          isFailure={status === 'FAILURE'}
        >
          {(!isReady || !isFadedOut) && this.renderSpinner()}

          {status === 'FAILURE' ? this.renderFailure() : this.renderComponent()}
        </MainContentWrapper>
      );
    }
  }

  return hoistNonReactStatics(FetchingView, Component);
};

export default createFetchingView;



// WEBPACK FOOTER //
// ./src/helpers/views.js